module.exports = __webpack_public_path__ + "img/motorcycle-parked-moved.b182f664.jpg";